import { colors, fontSizes } from "@hubrise/react-components"
import styled from "styled-components"

export const Section = styled.div`
  margin-top: 2rem;

  &:first-child {
    margin-top: 0.5rem;
  }
`

export const SectionHeader = styled.div`
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid ${colors.borderLight};
`

export const SectionTitle = styled.div`
  font-weight: 500;
  font-size: ${fontSizes._14};
`
